import {barChartSvg as Icon__small__barChartSvg} from '../Icon__small/Icon__small--barChart.js';

export var barChart = {
  name: 'barChart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__barChartSvg,
};
